/**
 * Attach `bookTitle` to manuscript rows for the # mention picker when series metadata is available.
 */
export function enrichDocumentsWithSeriesBookTitles(
  documentsRaw: unknown[] | null | undefined,
  project: { id?: string } | null | undefined,
  seriesBooks: unknown,
): unknown[] {
  const list = documentsRaw ?? [];
  if (!list.length) return list;

  const bookTitleByProjectId = new Map<string, string>();
  if (Array.isArray(seriesBooks) && seriesBooks.length > 0) {
    for (const book of seriesBooks as Array<{ projectId?: string; title?: string }>) {
      const pid = typeof book.projectId === "string" ? book.projectId.trim() : "";
      const t = typeof book.title === "string" ? book.title.trim() : "";
      if (pid && t) bookTitleByProjectId.set(pid, t);
    }
  }

  const currentPid = project?.id ?? "";
  const currentBookTitle = currentPid ? bookTitleByProjectId.get(currentPid) : undefined;

  return list.map((doc) => {
    if (!doc || typeof doc !== "object") return doc;
    const document = doc as {
      id?: unknown;
      bookTitle?: unknown;
      bookProjectId?: unknown;
      seriesBookProjectId?: unknown;
      projectId?: unknown;
    };
    if (typeof document.id !== "string" || !document.id.trim()) return doc;
    const existing = typeof document.bookTitle === "string" ? document.bookTitle.trim() : "";
    if (existing) return doc;

    const crossPid =
      (typeof document.bookProjectId === "string" && document.bookProjectId.trim()) ||
      (typeof document.seriesBookProjectId === "string" && document.seriesBookProjectId.trim()) ||
      (typeof document.projectId === "string" && document.projectId.trim() && document.projectId !== currentPid ? document.projectId : "");

    if (crossPid && bookTitleByProjectId.has(crossPid)) {
      return { ...doc, bookTitle: bookTitleByProjectId.get(crossPid)! };
    }

    if (currentBookTitle && bookTitleByProjectId.size > 0) {
      return { ...doc, bookTitle: currentBookTitle };
    }

    return doc;
  });
}
